import React from 'react'

import PropTypes from 'prop-types'
import {Box, Text, useMultiStyleConfig} from '@salesforce/retail-react-app/app/components/shared/ui'
import {InfoIcon} from '../icons/others'
import InfoPopover from '../popovers/info-popover'
import {remCalc} from '../../theme/_utils'

const BenefitCard = ({icon, children, infoPopoverTitle, infoPopoverDescription}) => {
    const styles = useMultiStyleConfig('BenefitCard')

    return (
        <Box {...styles.card}>
            {icon}
            <Text textStyle="body-small">{children}</Text>
            <Box marginLeft="auto" {...styles.infoPopBox}>
                <InfoPopover
                    variant="left-center"
                    trigger={
                        <InfoIcon
                            verticalAlign="initial"
                            aria-label="More Info"
                            boxSize={remCalc(16)}
                            // fill="button.text.secondary-default"
                            // color="button.text.primary-default"
                            cursor="pointer"
                        />
                    }
                    openTooltipOn="hover"
                    title={infoPopoverTitle}
                    description={infoPopoverDescription}
                />
            </Box>
        </Box>
    )
}

BenefitCard.propTypes = {
    icon: PropTypes.node,
    children: PropTypes.node,
    infoPopoverTitle: PropTypes.string,
    infoPopoverDescription: PropTypes.string,
}

export default BenefitCard
